export default "__VITE_ASSET__CI6SDLR2__"